(function() {
  "use strict";

  angular.module("PrintixLanguageMenu", ["pascalprecht.translate"])

    .constant("CAPTIONS_SUFFIX", {
      "printix-client": "Caption_App_",
      "printix-admin": "Caption_Admin_",
      "printix-auth": "Caption_Auth_",
      "printix-download": "Caption_Download_",
      "printix-technician": "Caption_Tech_"
    })

    .constant("CAPTIONS_URLS", {
      MAIN_URL: "https://assets.printix.net/captions"
    })

    .constant("RequiredLanguageItemProperties", ["NativeName", "LanguageCode"])

    .controller("LanguageMenuController", ["$rootScope", "$scope", "$translate", "$filter", "amMoment", "Utils",
      "CAPTIONS_URLS", "RequiredLanguageItemProperties", "$http", "$ngBootbox", "$timeout",
      function($rootScope, $scope, $translate, $filter, amMoment, Utils, CAPTIONS_URLS, RequiredLanguageItemProperties,
        $http, $ngBootbox, $timeout) {

        //Var declaration
        $scope.captionList = [];

        $scope.currentLanguageCode = function() {
          return $translate.use().toLowerCase();
        };

        $scope.setBootboxLanguage = function() {
          $ngBootbox.addLocale($translate.use().toLowerCase(), {
            OK: $filter("translate")("Ok"),
            CANCEL: $filter("translate")("Cancel"),
            CONFIRM: $filter("translate")("Confirm")
          });
          $ngBootbox.setLocale($translate.use().toLowerCase());
        };

        $scope.setDateRangePickerLanguage = function() {
          var dateRangePickerLanguage = {
            separator: "-",
            applyLabel: $filter("translate")("Apply"),
            cancelLabel: $filter("translate")("Cancel"),
            fromLabel: $filter("translate")("From"),
            toLabel: $filter("translate")("To"),
            customRangeLabel: $filter("translate")("Custom"),
            daysOfWeek: [
              $filter("translate")("SundayShort"),
              $filter("translate")("MondayShort"),
              $filter("translate")("TuesdayShort"),
              $filter("translate")("WednesdayShort"),
              $filter("translate")("ThursdayShort"),
              $filter("translate")("FridayShort"),
              $filter("translate")("SaturdayShort")
            ],
            monthNames: [
              $filter("translate")("January"),
              $filter("translate")("February"),
              $filter("translate")("March"),
              $filter("translate")("April"),
              $filter("translate")("May"),
              $filter("translate")("June"),
              $filter("translate")("July"),
              $filter("translate")("August"),
              $filter("translate")("September"),
              $filter("translate")("October"),
              $filter("translate")("November"),
              $filter("translate")("December")
            ]
          };
          if (dateRangePickerLanguage.daysOfWeek[0].length > 2) {
            $timeout(function(){
              $scope.setDateRangePickerLanguage()
            }, 100)
          } else {
            $rootScope.dateRangePickerLanguage = dateRangePickerLanguage;
          }
        };

        $scope.changeLanguage = function(languageCode) {
          if (languageCode && languageCode.toLowerCase() !== $translate.use().toLowerCase()) {
            $translate.use(languageCode).then(function () {
              $scope.setBootboxLanguage();
              $scope.setDateRangePickerLanguage();
              amMoment.changeLocale($translate.use().toLowerCase());
              $rootScope.$broadcast("LANGUAGE_CHANGED");
            });
          }
        };

        $scope.readCaptionsRequest = function(response) {
          $scope.captionList = [];
          angular.forEach(response.data.Languages, function(caption) {
            if (Utils.objectPropertiesCheck(caption, RequiredLanguageItemProperties)) {
              $scope.captionList.add(caption);
            } else {
              console.log("invalid caption object");
              console.log(caption);
            }
          });
          $rootScope.sharedCaptionList = $scope.captionList;
        };

        $scope.loadCaptions = function() {
          $http.get(CAPTIONS_URLS.MAIN_URL + "/Captions.2025.4.json", {
            cache: true
          }).then($scope.readCaptionsRequest);
        };

        $scope.extractLanguageKey = function(languageKey) {
          var languageKeyToUse = '';
          if (languageKey.split('_').length > 1) {
            languageKeyToUse = languageKey.split('_')[0];
          } else if (languageKey.split('-').length > 1) {
            languageKeyToUse = languageKey.split('-')[0];
          } else {
            languageKeyToUse = languageKey;
          }
          return languageKeyToUse;
        }

        $rootScope.$watch("currentUser.info._embedded.user.language", function() {
          if ($rootScope.currentUser && $rootScope.currentUser.info && $rootScope.currentUser.info._embedded.user.language) {
            var caption = $scope.extractLanguageKey($rootScope.currentUser.info._embedded.user.language)
            $scope.changeLanguage(caption);
          }
        });

        //Function triggers
        if ($scope.captionList.length < 1) {
          $scope.loadCaptions();
        }

        amMoment.changeLocale($translate.use().toLowerCase());
        $scope.setBootboxLanguage();
        $scope.setDateRangePickerLanguage();
      }
    ])

    .config(["$translateProvider", "CAPTIONS_SUFFIX", "CAPTIONS_URLS",
      function($translateProvider, CAPTIONS_SUFFIX, CAPTIONS_URLS) {
        $translateProvider.useStaticFilesLoader({
          prefix: CAPTIONS_URLS.MAIN_URL + "/" + CAPTIONS_SUFFIX[angular.element("html").attr("ng-app")],
          suffix: ".json"
        });

        $translateProvider.preferredLanguage("en");

        $translateProvider.useLocalStorage();

      }
    ]);
})();